import isObject from "../struct-events/is-object.js";
import Tracker from "../prop-trackers/tracker.js";
import PropTracker from "../prop-trackers/prop-tracker.js";
import TrackerGroup from "../prop-trackers/tracker-group.js";

class DeepChangeTracker extends Tracker {
    constructor(strEvtCtx) {
        super();

        this._strEvtCtx = strEvtCtx;

        this._propTracker = new PropTracker();

        this._subTrackers = {};
        this._subTrackerGroup = new TrackerGroup();

        const needsUpdate = () => this.protected_needsUpdate();
        this._propTracker.listenNeedsUpdate(needsUpdate);
        this._subTrackerGroup.listenNeedsUpdate(needsUpdate);
    }

    track(object, events) {
        this._propTracker.track(object, events);
    }

    protected_startUpdate() {
        this._propTracker.update(({ props }) => {
            for (const { key, newValue } of props.iterateModified()) {
                let tracker = this._subTrackers[key];

                if (isObject(newValue)) {
                    if (!tracker) {
                        tracker = new DeepChangeTracker(this._strEvtCtx);
                        this._subTrackers[key] = tracker;
                        this._subTrackerGroup.add(tracker);
                    }

                    tracker.track(newValue, this._strEvtCtx.getEvents(newValue));
                } else {
                    if (tracker) {
                        tracker.track();
                        delete this._subTrackers[key];
                        this._subTrackerGroup.remove(tracker);
                    }
                }
            }
        });

        this._subTrackerGroup.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update();
            }
        });
    }

    protected_finishUpdate() {}
}

export default DeepChangeTracker;
